import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Paper, Typography, useMediaQuery } from '@mui/material';
import { publicScoreGame, scoreGame } from '../../../features/game/gameSlice';
import { GameStatus } from '../../../constants/gameConstants';
import ColorLine from '../colorDot/colorLine';

const ScoreControl = ({ game, team, isPublic }) => {
  const dispatch = useDispatch();
  const scoringGame = useSelector((state) => state.game.scoringGame);
  const currentSet = game.sets.find((set) => set.id === game.currentSet);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const [multiplierActive, setMultiplierActive] = React.useState(false);

  const getGameTypePlayers = () => {
    switch (game.gameFormat.gameType) {
      case 2: // Singles
        return 1;
      case 1: // Pairs
        return 2;
      case 3: // Triples
        return 3;
      case 4: // Fours
        return 4;
      default:
        return 1; // Default to singles if unknown
    }
  };

  const maxScorePerEnd = game.gameFormat.numBowls * getGameTypePlayers();

  if (
    game.status === GameStatus.COMPLETE ||
    game.status === GameStatus.PLAYOFF ||
    currentSet?.isDone
  ) {
    return null;
  }

  const handleScoreUpdate = (scoreValue) => {
    if (isPublic) {
      dispatch(
        publicScoreGame({ gameId: game.id, teamId: team.id, scoreValue, multiplierActive })
      ).then(() => {
        if (game.gameFormat.multiplier > 1) {
          setMultiplierActive(false);
        }
      });
    } else {
      dispatch(scoreGame({ gameId: game.id, teamId: team.id, scoreValue, multiplierActive })).then(
        () => {
          if (game.gameFormat.multiplier > 1) {
            setMultiplierActive(false);
          }
        }
      );
    }
  };

  const scoreButton = (value) => {
    return (
      <Box
        m={!isMobile ? '5px' : '2px'}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <Button
          variant={'contained'}
          color={multiplierActive ? 'primary' : 'background'}
          disabled={scoringGame}
          sx={{
            width: !isMobile ? 40 : 30,
            height: !isMobile ? 40 : 30,
            borderRadius: 3,
            fontWeight: 'bold'
          }}
          onClick={() => handleScoreUpdate(value)}>
          {value}
        </Button>
      </Box>
    );
  };

  const activateMultipler = () => {
    if (game.gameFormat.multiplier > 1) {
      setMultiplierActive(!multiplierActive);
    }
  };

  const multiplierButton = (value) => {
    return (
      <Box
        m={!isMobile ? '5px' : '2px'}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <Button
          variant={'contained'}
          backgroundColor={multiplierActive ? 'background' : 'primary'}
          color={multiplierActive ? 'primary' : 'white'}
          disabled={scoringGame}
          sx={{
            m: 1,
            // width: !isMobile ? 40 : 30,
            // height: !isMobile ? 40 : 30,
            borderRadius: 3,
            fontWeight: 'bold',
            //textTransform: 'lowercase',
            border: '2px solid ',
            borderColor: 'primary.main'
          }}
          onClick={() => activateMultipler()}>
          Power Play
        </Button>
      </Box>
    );
  };

  const scoreZeroButton = () => {
    return (
      <Box
        m={!isMobile ? '5px' : '2px'}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <Button
          variant={'contained'}
          color={'background'}
          elevation={2}
          disabled={scoringGame}
          onClick={() => handleScoreUpdate(0)}
          sx={{ width: '100%', height: !isMobile ? 40 : 30, borderRadius: 3, fontWeight: 'bold' }}>
          {0}
        </Button>
      </Box>
    );
  };

  return (
    <Paper
      sx={{
        mt: 3,
        width: !isMobile ? '234px' : '170px',
        alignSelf: 'center',
        borderRadius: 5,
        p: '5px'
      }}>
      <Box display={'flex'} flexDirection={'column'} alignItems={'center'} pt={1}>
        <ColorLine color={team.color} />
        {game.gameFormat.multiplier &&
          game.gameFormat.multiplier > 1 &&
          multiplierButton(game.gameFormat.multiplier)}
        <Box display={'flex'} flexDirection={'row'} flexWrap={'wrap'} justifyContent={'center'}>
          {Array.from({ length: maxScorePerEnd }, (_, i) =>
            scoreButton(multiplierActive ? game.gameFormat.multiplier * (i + 1) : i + 1)
          )}
        </Box>
        <Box display={'flex'} flexDirection={'row'} flexWrap={'wrap'}>
          {scoreZeroButton()}
        </Box>
      </Box>
    </Paper>
  );
};

export default ScoreControl;
